import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "icon fa-regular fa-chart-bar"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 0,
  class: "icon bi bi-list-ul"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 0,
  class: "badge"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 0,
  class: "icon bi bi-moon-fill theme-icon"
}
const _hoisted_10 = {
  key: 1,
  class: "icon bi bi-sun-fill theme-icon"
}
const _hoisted_11 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hasRole('ROLE_FORMS_MOBILE'))
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 0,
          id: "kt_header_vehicles_details_menu_toggle",
          class: "d-flex align-items-center ms-1 ms-lg-3 justify-content-end",
          "data-bs-toogle": "tooltip",
          "data-bs-placement": "bottom",
          title: _ctx.$t('userMenu.buttons.history'),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openHistory && _ctx.openHistory(...args)))
        }, [
          (_ctx.route.name === 'Map')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("", true)
        ], 8, _hoisted_2)), [
          [_directive_tooltip]
        ])
      : _createCommentVNode("", true),
    (!_ctx.hasRole('ROLE_FORMS_MOBILE'))
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 1,
          id: "kt_header_assets_list_menu_toggle",
          class: "d-flex align-items-center ms-1 ms-lg-3 justify-content-end",
          "data-bs-toogle": "tooltip",
          "data-bs-placement": "bottom",
          title: _ctx.$t('userMenu.buttons.assetsList'),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openAssetsList && _ctx.openAssetsList(...args)))
        }, [
          (_ctx.route.name === 'AssetsMap')
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true)
        ], 8, _hoisted_4)), [
          [_directive_tooltip]
        ])
      : _createCommentVNode("", true),
    (!_ctx.hasRole('ROLE_FORMS_MOBILE'))
      ? _withDirectives((_openBlock(), _createElementBlock("div", {
          key: 2,
          id: "kt_header_notifications_menu_toggle",
          class: "d-flex align-items-center ms-1 ms-lg-3 justify-content-end position-relative",
          "data-bs-toogle": "tooltip",
          "data-bs-placement": "bottom",
          title: _ctx.$t('userMenu.buttons.notifications'),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openNotifications && _ctx.openNotifications(...args)))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "icon fa-regular fa-comment-dots" }, null, -1)),
          (_ctx.unreadCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.unreadCount), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_6)), [
          [_directive_tooltip]
        ])
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      key: _ctx.isDarkTheme,
      class: "d-flex align-items-center ms-1 ms-lg-3 justify-content-end",
      "data-bs-toogle": "tooltip",
      "data-bs-placement": "bottom",
      title: _ctx.themeTooltip,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args)))
    }, [
      (_ctx.isDarkTheme)
        ? (_openBlock(), _createElementBlock("i", _hoisted_9))
        : (_openBlock(), _createElementBlock("i", _hoisted_10))
    ], 8, _hoisted_8)), [
      [_directive_tooltip]
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      id: "kt_header_user_menu_toggle",
      class: "d-flex align-items-center ms-1 ms-lg-3 justify-content-end",
      "data-bs-toogle": "tooltip",
      "data-bs-placement": "bottom",
      title: _ctx.$t('userMenu.buttons.settings'),
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openSettings && _ctx.openSettings(...args)))
    }, [...(_cache[6] || (_cache[6] = [
      _createElementVNode("span", { class: "icon fa-regular fa-circle-user" }, null, -1)
    ]))], 8, _hoisted_11)), [
      [_directive_tooltip]
    ])
  ]))
}